/*
 * consent-mode-shopify.js — 05/10/2026, compteur ajoute le 06/10/2026
 *
 * DEUX roles :
 *
 * 1) DECLARER le consentement a Google (Consent Mode). Remplace
 *    assets/avada-cookiebar-gcm-integration.js, reste de l'application Avada
 *    desinstallee. C'etait Google Tag Manager qui portait cette fonction
 *    avant sa suppression du 03/09/2026 ; le fichier Avada en avait herite
 *    par accident. Pilote ici par l'API Customer Privacy de Shopify.
 *
 * 2) COMPTER les reponses au bandeau cookies. Depuis la desinstallation
 *    d'Avada, plus aucun outil ne donne le taux d'acceptation : le tableau de
 *    bord Avada est parti avec l'app, et le bandeau natif de Shopify ne
 *    publie aucune statistique. On envoie donc nous-memes un evenement GA4
 *    "cookie_consent" avec le choix du visiteur.
 *
 * Ou lire le resultat : GA4 > Rapports > Engagement > Evenements >
 * cookie_consent, puis ventiler par le parametre "choice"
 * (accepted / refused / no_answer). Pour que "choice" soit utilisable comme
 * dimension, le declarer une fois dans GA4 : Admin > Definitions
 * personnalisees > Creer une dimension personnalisee, portee Evenement,
 * parametre "choice".
 *
 * Pourquoi l'evenement part meme en cas de refus : avec le Consent Mode
 * avance, GA4 accepte des pings anonymes sans cookie ni identifiant. On ne
 * depose rien et on ne collecte aucune donnee personnelle - on compte
 * seulement, de maniere agregee, combien de personnes acceptent ou refusent.
 *
 * Envoye une seule fois par session (sessionStorage) pour ne pas gonfler le
 * nombre d'evenements a chaque page vue.
 */
(function () {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  // --- 1) Consent Mode -----------------------------------------------------
  try {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) { console.error('consent-tracking-api non charge', err); }
      });
    }
  } catch (e) {}

  function cp() { return window.Shopify && window.Shopify.customerPrivacy; }

  function readState() {
    var p = cp();
    var mustAsk = !p || (typeof p.shouldShowBanner === 'function' && p.shouldShowBanner());
    function allowed(fn) {
      if (mustAsk) return false;
      try { return typeof p[fn] === 'function' ? !!p[fn]() : true; } catch (e) { return false; }
    }
    return {
      mustAsk: mustAsk,
      marketing: allowed('marketingAllowed'),
      analytics: allowed('analyticsProcessingAllowed'),
      functional: allowed('preferencesProcessingAllowed')
    };
  }

  var s = readState();

  if (!s.marketing) { gtag('set', 'ads_data_redaction', true); }
  gtag('set', 'url_passthrough', true);

  gtag('default', {
    ad_storage:              s.marketing  ? 'granted' : 'denied',
    ad_user_data:            s.marketing  ? 'granted' : 'denied',
    ad_personalization:      s.marketing  ? 'granted' : 'denied',
    analytics_storage:       s.analytics  ? 'granted' : 'denied',
    functionality_storage:   s.functional ? 'granted' : 'denied',
    personalization_storage: s.functional ? 'granted' : 'denied',
    security_storage:        'granted',
    wait_for_update:         500
  });

  // --- 2) Compteur accepte / refuse ---------------------------------------
  var SENT_KEY = 'ars_consent_counted';

  function label(state) {
    if (state.mustAsk) return 'no_answer';
    if (state.marketing && state.analytics) return 'accepted';
    if (!state.marketing && !state.analytics) return 'refused';
    return 'partial';
  }

  function alreadySent() {
    try { return sessionStorage.getItem(SENT_KEY); } catch (e) { return null; }
  }
  function markSent(v) {
    try { sessionStorage.setItem(SENT_KEY, v); } catch (e) {}
  }

  function count(choice, moment) {
    if (alreadySent() === choice) return;
    markSent(choice);
    gtag('event', 'cookie_consent', {
      choice: choice,                 // accepted | refused | partial | no_answer
      moment: moment,                 // page_load | user_action
      non_interaction: true
    });
  }

  // Etat au chargement : repondu avant, ou bandeau encore affiche.
  // Petit delai : l'API Customer Privacy n'est pas toujours prete tout de suite.
  setTimeout(function () { count(label(readState()), 'page_load'); }, 1200);

  // Le moment ou le visiteur clique reellement sur Accepter / Refuser.
  document.addEventListener('visitorConsentCollected', function () {
    var now = readState();
    now.mustAsk = false; // il vient de repondre
    markSent('');        // on autorise un deuxieme envoi : le choix reel
    count(label(now), 'user_action');
  });
})();
